import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Format a number with spaces as thousand separators
 * @param value - The number to format
 * @param decimals - Number of decimal places to show (optional)
 * @returns Formatted string with spaces, e.g., "12 537.50"
 */
export function formatNumber(value: number, decimals?: number): string {
  if (!isFinite(value)) return '0';

  const formatted = decimals !== undefined ? value.toFixed(decimals) : String(value);
  const [whole, decimal] = formatted.split('.');

  // Positive value that rounds to zero at this precision → prefix with ~
  const prefix =
    decimals !== undefined && value > 0 && value < Math.pow(10, -decimals)
      ? '~'
      : '';

  // Add spaces every 3 digits from the right
  const formattedWhole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

  return decimal !== undefined
    ? `${prefix}${formattedWhole},${decimal}`
    : `${prefix}${formattedWhole}`;
}
